if (!customElements.get("media-gallery")) {
  class e extends HTMLElement {
    constructor() {
      super(), Shopify.designMode ? setTimeout(() => this.init(), 200) : this.init()
    }
    disconnectedCallback() {
      window.removeEventListener("on:debounced-resize", this.resizeHandler), this
        .resizeInitHandler && window.removeEventListener("on:debounced-resize", this
          .resizeInitHandler), this.zoomInitHandler && window.removeEventListener(
          "on:debounced-resize", this.zoomInitHandler)
    }
    init() {
      this.section = this.closest(".js-product"), this.mediaGroupingEnabled = this.hasAttribute(
          "data-media-grouping-enabled") && this.getMediaGroupData(), this.stackedScroll = this
        .dataset.stackedScroll, this.stackedUnderline = "true" === this.dataset
        .stackedUnderline && !this.mediaGroupingEnabled, this.isFeatured = "true" === this.dataset
        .isFeatured, this.viewer = this.querySelector(".media-viewer"), this.thumbs = this
        .querySelector(".media-thumbs"), this.thumbsItems = this.querySelectorAll(
          ".media-thumbs__item"), this.controls = this.querySelector(".media-ctrl"), this
        .prevBtn = this.querySelector('.media-ctrl__btn[name="prev"]'), this.nextBtn = this
        .querySelector('.media-ctrl__btn[name="next"]'), this.counterCurrent = this.querySelector(
          ".media-ctrl__current-item"), this.counterTotal = this.querySelector(
          ".media-ctrl__total-items"), this.liveRegion = this.querySelector(
          ".media-gallery__status"), this.zoomLinks = this.querySelectorAll(".js-zoom-link"), this
        .loadingSpinner = this.querySelector(".loading-spinner"), this.xrButton = this
        .querySelector(".media-xr-button"), this.hideVariantMediaUntilSelected = this.hasAttribute("data-hide-variant-media-until-selected"), this.variantSelectionInteracted = !1, this.hideVariantMediaUntilSelected && (this.section.addEventListener("change", e => {
          e.isTrusted && e.target.closest("variant-picker") && (this.variantSelectionInteracted = !0)
        }, !0), this.section.addEventListener("click", e => {
          e.isTrusted && e.target.closest("variant-picker") && (this.variantSelectionInteracted = !0)
        }, !0), this.section.addEventListener("keydown", e => {
          e.isTrusted && e.target.closest("variant-picker") && (this.variantSelectionInteracted = !0)
        }, !0), this.showOnlySelectedVariantMedia(this.dataset.initialVariantMediaId)), this.mediaGroupingEnabled && this.setActiveMediaGroup(
          this.getMediaGroupFromOptionSelectors()), "stacked" === this.dataset.layout && theme
        .mediaMatches.md ? (this.resizeInitHandler = this.resizeInitHandler || this.initGallery
          .bind(this), window.addEventListener("on:debounced-resize", this.resizeInitHandler),
          this.setVisibleItems(), this.previousMediaItem = this.querySelector(
            ".media-viewer__item.is-current-variant"), setTimeout(() => this.customSetActiveMedia(
            this.previousMediaItem, "always" === this.stackedScroll), 200)) : this.initGallery(),
        this.zoomLinks && (this.zoomInitHandler = this.zoomInitHandler || this.initZoom.bind(
          this), this.zoomEventListener = this.zoomEventListener || this.handleZoomMouseMove.bind(
            this), window.addEventListener("on:debounced-resize", this.zoomInitHandler), this
          .initZoom(), this.zoomLinks.forEach(e => {
            e.addEventListener("click", e => {
              e.preventDefault()
            })
          })), this.section.addEventListener("on:variant:change", this.onVariantChange.bind(this))
    }
    onVariantChange(e) {
      if (this.updatePreorderBadge(e.detail.variant), this.hideVariantMediaUntilSelected && !this.variantSelectionInteracted && !this.dataset.initialVariantMediaId) return;
      this.hideVariantMediaUntilSelected && e.detail.variant && this.showOnlySelectedVariantMedia(e.detail.variant.featured_media && e.detail.variant.featured_media.id);
      if (this.mediaGroupingEnabled && this.setActiveMediaGroup(this
          .getMediaGroupFromOptionSelectors()), e.detail.variant && e.detail.variant
        .featured_media) {
        let t = this.viewer.querySelector(
          `[data-media-id="${e.detail.variant.featured_media.id}"]`);
        this.customSetActiveMedia(t, !0)
      }
    }
    updatePreorderBadge(e) {
      let t = this.querySelector(".media-gallery__preorder-badge");
      if (!t) return;
      let i = (this.dataset.preorderVariantIds || "").split(",").map(e => e.trim()).filter(Boolean);
      t.hidden = !e || !i.includes(String(e.id))
    }
    showOnlySelectedVariantMedia(e) {
      let t = e ? String(e) : null;
      this.querySelectorAll("[data-variant-media]").forEach(e => {
        let i = e.hasAttribute("data-first-product-media"), s = t && e.dataset.mediaId === t;
        e.style.display = s || !t && i ? "" : "none"
      });
      if (t) {
        let e = this.viewer && this.viewer.querySelector(`[data-media-id="${t}"]`), i = this.thumbs && this.thumbs.querySelector(`[data-media-id="${t}"]`);
        e && this.viewer.prepend(e), i && this.thumbs.prepend(i)
      }
      this.viewer && this.setVisibleItems()
    }
    getMediaGroupFromOptionSelectors() {
      let e = this.section.querySelectorAll(".option-selector");
      if (e.length > this.getMediaGroupData().groupOptionIndex) {
        let t = e[this.getMediaGroupData().groupOptionIndex];
        return "dropdown" === t.dataset.selectorType ? t.querySelector(".custom-select__btn")
          .textContent.trim() : t.querySelector("input:checked").value
      }
      return null
    }
    getMediaGroupData() {
      if (void 0 === this.variantMediaData) {
        let e = this.querySelector(".js-data-variant-media");
        this.variantMediaData = !!e && JSON.parse(e.textContent)
      }
      return this.variantMediaData
    }
    getMediaGroupMap() {
      if (!this.mediaGroupMap) {
        this.mediaGroupMap = {
          groups: {}
        };
        let e = this.getMediaGroupData(),
          t = !1;
        this.viewerItems = this.querySelectorAll(".media-viewer__item"), this.viewerItems.forEach(
          i => {
            for (let s = 0; s < e.variantMedia.length; s += 1) parseInt(i.dataset.mediaId,
              10) === e.variantMedia[s].mediaId && t !== e.variantMedia[s].option && (t = e
                .variantMedia[s].option);
            if (t) {
              this.mediaGroupMap.groups[t] || (this.mediaGroupMap.groups[t] = {
                name: t,
                items: []
              });
              let r = {
                main: i
              };
              this.thumbs && (r.thumb = this.thumbs.querySelector(
                  `[data-media-id="${i.dataset.mediaId}"].media-thumbs__item`)), this
                .mediaGroupMap.groups[t].items.push(r)
            }
          }), this.mediaGroupMap.groupFromItem = e => {
          let t = Object.keys(this.mediaGroupMap.groups);
          for (let i = 0; i < t; i += 1) {
            let s = t[i];
            for (let r = 0; r < this.mediaGroupMap.groups[s].items.length; r += 1)
              if (this.mediaGroupMap.groups[s].items[r] === e) return this.mediaGroupMap.groups[
                s]
          }
          return this.mediaGroupMap.groups[Object.keys(this.mediaGroupMap.groups)[0]]
        }
      }
      return this.mediaGroupMap
    }
    setActiveMediaGroup(e) {
      let t = this.getMediaGroupMap(),
        i = e ? t.groups[e] : t.groupFromItem(this.currentItem);
      if (i) {
        if (this.currentGroup !== i) {
          this.currentGroup = i, this.viewerItems.forEach(e => {
            e.style.display = "none", e.classList.remove("media-viewer__item--single")
          }), this.thumbsItems.forEach(e => {
            e.style.display = "none"
          });
          let s = !1;
          i.items.forEach(e => {
              e.main.style.display = "", e.thumb && (e.thumb.style.display = ""), e.main ===
                this.currentItem && (s = !0)
            }), this.setVisibleItems(), s || this.customSetActiveMedia(i.items[0].main, !0), 1 ===
            i.items.length && i.items[0].main.classList.add("media-viewer__item--single")
        }
      } else this.viewerItems.forEach(e => {
        e.style.display = ""
      }), this.thumbsItems.forEach(e => {
        e.style.display = ""
      })
    }
    initGallery() {
      if (this.setVisibleItems(), this.visibleItems.length <= 1) return;
      this.viewerItemOffset = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft,
        this.currentIndex = Math.round(this.viewer.scrollLeft / this.viewerItemOffset), this
        .currentItem = this.visibleItems[this.currentIndex], this.addListeners(), this.thumbs &&
        this.currentItem && (this.currentThumb = this.thumbs.querySelector(
          `[data-media-id="${this.currentItem.dataset.mediaId}"]`)), !this.isFeatured && document
        .hasFocus() && this.viewer.querySelectorAll('.product-image[loading="lazy"]').forEach((e,
          t) => {
          setTimeout(() => {
            e.loading = "eager"
          }, 500 * (t + 1))
        });
      let e = this.querySelector(".media-viewer__item.is-current-variant");
      this.customSetActiveMedia(e, !0)
    }
    addListeners() {
      this.viewer.addEventListener("scroll", this.handleScroll.bind(this)), this.controls && this
        .controls.addEventListener("click", this.handleNavClick.bind(this)), this.thumbs && this
        .thumbs.addEventListener("click", this.handleThumbClick.bind(this)), this.resizeHandler =
        this.resizeHandler || this.handleResize.bind(this), window.addEventListener(
          "on:debounced-resize", this.resizeHandler)
    }
    initZoom() {
      this.zoomLinks.forEach(e => {
        let t = Number(e.querySelector(".zoom-image").dataset.originalWidth || 0),
          i = e.querySelector(".product-image").getBoundingClientRect().width;
        theme.mediaMatches.md && t - 75 > i ? (e.addEventListener("mousemove", this
          .zoomEventListener), e.classList.remove("pointer-events-none")) : (e
          .removeEventListener("mousemove", this.zoomEventListener), e.classList.add(
            "pointer-events-none"))
      })
    }
    handleZoomMouseMove(e) {
      let t = e.currentTarget,
        i = t.querySelector(".js-zoom-image");
      if (i.dataset.src) {
        this.loadingSpinner.classList.remove("loading-spinner--out");
        let s = new Image;
        s.src = i.dataset.src, s.onload = () => {
          i.src = s.src, t.classList.remove("media--zoom-not-loaded"), this.loadingSpinner
            .classList.add("loading-spinner--out")
        }, i.removeAttribute("data-src")
      }
      try {
        let r = e.offsetX ? e.offsetX : e.touches[0].pageX,
          a = e.offsetY ? e.offsetY : e.touches[0].pageY,
          n = r / i.offsetWidth * 100,
          o = a / i.offsetHeight * 100;
        i.style.objectPosition = `${n}% ${o}%`
      } catch (h) {}
    }
    handleScroll() {
      let e = Math.round(this.viewer.scrollLeft / this.viewerItemOffset);
      if (e !== this.currentIndex) {
        let t = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
        t === this.viewerItemOffset && this.customSetActiveMedia(this.visibleItems[e], !1)
      }
    }
    handleNavClick(e) {
      if (!e.target.matches(".media-ctrl__btn")) return;
      let t = e.target === this.nextBtn ? this.visibleItems[this.currentIndex + 1] : this
        .visibleItems[this.currentIndex - 1];
      this.viewer.scrollTo({
        left: t.offsetLeft,
        behavior: "smooth"
      })
    }
    handleThumbClick(t) {
      let i = t.target.closest("[data-media-id]");
      if (!i) return;
      let s = this.querySelector(`[data-media-id="${i.dataset.mediaId}"]`);
      this.customSetActiveMedia(s), e.playActiveMedia(s)
    }
    handleResize() {
      this.viewerItemOffset = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft,
        this.thumbs && this.currentThumb && this.checkThumbVisibilty(this.currentThumb)
    }
    setActiveMedia() {}
    customSetActiveMedia(e, t = !0) {
      if (e !== this.currentItem) {
        if (window.pauseAllMedia(this), this.currentItem = e, this.currentIndex = this
          .visibleItems.indexOf(this.currentItem), "stacked" === this.dataset.layout && theme
          .mediaMatches.md) {
          if (this.stackedUnderline && (this.previousMediaItem && this.previousMediaItem.classList
              .remove("is-active"), e.classList.add("is-active"), this.previousMediaItem = e),
            "never" !== this.stackedScroll) {
            let i = e.getBoundingClientRect().top + document.documentElement.scrollTop - 150;
            Math.abs(i - document.documentElement.scrollTop) > 300 && window.scrollTo({
              top: i < 100 ? 0 : i,
              behavior: "smooth"
            })
          }
          return
        }
        t && this.viewer.scrollTo({
            left: this.currentItem.offsetLeft
          }), this.thumbs && this.setActiveThumb(), this.controls && (this.prevBtn && (this
              .prevBtn.disabled = 0 === this.currentIndex), this.nextBtn && (this.nextBtn
              .disabled = this.currentIndex === this.visibleItems.length - 1), this
            .counterCurrent && (this.counterCurrent.textContent = this.currentIndex + 1)), this
          .announceLiveRegion(this.currentItem, this.currentIndex + 1), this.xrButton &&
          "model" === e.dataset.mediaType && (this.xrButton.dataset.shopifyModel3dId = e.dataset
            .mediaId)
      }
    }
    setActiveThumb() {
      this.currentThumb = this.thumbs.querySelector(
        `[data-media-id="${this.currentItem.dataset.mediaId}"]`);
      let e = this.currentThumb.querySelector("button");
      this.thumbs.querySelectorAll(".media-thumbs__btn").forEach(e => {
          e.classList.remove("is-active"), e.removeAttribute("aria-current")
        }), e.classList.add("is-active"), e.setAttribute("aria-current", "true"), this
        .checkThumbVisibilty(this.currentThumb)
    }
    setVisibleItems() {
      this.viewerItems = this.querySelectorAll(".media-viewer__item"), this.visibleItems = Array
        .from(this.viewerItems).filter(e => e.clientWidth > 0), this.counterTotal && (this
          .counterTotal.textContent = this.visibleItems.length)
    }
    checkThumbVisibilty(e) {
      let t = this.thumbs.scrollLeft,
        i = this.thumbs.clientWidth + t,
        s = e.offsetLeft;
      (s + e.clientWidth > i || s < t) && this.thumbs.scrollTo({
        left: s,
        behavior: "smooth"
      })
    }
    announceLiveRegion(e, t) {
      let i = e.querySelector(".media-viewer img");
      i && (this.liveRegion.setAttribute("aria-hidden", "false"), this.liveRegion.innerHTML =
        theme.strings.imageAvailable.replace("[index]", t), setTimeout(() => {
          this.liveRegion.setAttribute("aria-hidden", "true")
        }, 2e3))
    }
    static playActiveMedia(e) {
      window.pauseAllMedia();
      let t = e.querySelector("deferred-media");
      t && t.loadContent()
    }
  }
  customElements.define("media-gallery", e)
}
